import { render, staticRenderFns } from "./updatePasswordForm.vue?vue&type=template&id=3b1e71ac&scoped=true"
import script from "./updatePasswordForm.vue?vue&type=script&lang=js"
export * from "./updatePasswordForm.vue?vue&type=script&lang=js"
import style0 from "./updatePasswordForm.vue?vue&type=style&index=0&id=3b1e71ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e71ac",
  null
  
)

export default component.exports